let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iWLC2")).then(() => parcelRequire('dKNUD'));